"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

exports.__esModule = true;
exports.menuItemPropTypes = exports.menuGroupPropTypes = exports.menuDividerPropTypes = exports.menuPropTypes = exports.menuItemsPropType = exports.menuItemPropType = void 0;

var _propTypes = require("prop-types");

var _constants = require("./constants");

var variant = (0, _propTypes.oneOf)(Object.keys(_constants.VARIANT));
var menuItemPropType = (0, _propTypes.shape)({
  iconEnd: _propTypes.element,
  iconStart: _propTypes.element,
  disabled: _propTypes.bool,
  divider: _propTypes.bool,
  onClick: _propTypes.func,
  render: _propTypes.func,
  secondaryText: _propTypes.node,
  text: _propTypes.node,
  title: _propTypes.node,
  value: _propTypes.string,
  variant: variant
});
exports.menuItemPropType = menuItemPropType;
var menuItemsPropType = (0, _propTypes.arrayOf)(menuItemPropType);
exports.menuItemsPropType = menuItemsPropType;
var menuPropTypes = {
  children: _propTypes.node,
  data: menuItemsPropType,
  highlightedIndex: _propTypes.number,
  item: _propTypes.func,
  itemKey: _propTypes.string
};
exports.menuPropTypes = menuPropTypes;
var menuDividerPropTypes = {};
exports.menuDividerPropTypes = menuDividerPropTypes;
var menuGroupPropTypes = {
  children: _propTypes.node,
  title: _propTypes.node
};
exports.menuGroupPropTypes = menuGroupPropTypes;
var menuItemPropTypes = {
  children: _propTypes.node,
  disabled: _propTypes.bool,
  iconEnd: _propTypes.element,
  iconStart: _propTypes.element,
  index: _propTypes.number,
  isHighlighted: _propTypes.bool,
  item: menuItemPropType,
  onClick: _propTypes.func,
  render: _propTypes.func,
  secondaryText: _propTypes.node,
  variant: variant
};
exports.menuItemPropTypes = menuItemPropTypes;